import React, { Fragment } from "react";
import { Link } from "react-router";
import CardCreate from "./helper/CardCreate";
import CardInnerContent from "./helper/CardInnerContent";
import "./linkStyle.css";

const regex = /([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\:\&\s])/g;

function Cards(props) {
  const { data, heading, footer, link, border, sortedData, compare } = props;
  // ***************** new *******************
  let sorted_compare_portfolios = [];
  if (data) {
    let x = sortedData.filter(
      (e) => e.client_portfolio_id === data["scenario_id"]
    );
    // let y = compare.filter(
    //   (e) => e.scenario_id === data["client_portfolio_id"]
    // );

    x.map((e) => sorted_compare_portfolios.push(e));
    // y.map((e) => sorted_compare_portfolios.push(e));
  }
  if (sorted_compare_portfolios.length) {
    sorted_compare_portfolios
      .filter((e) => e)
      .sort((a, b) => a.scenario_id - b.scenario_id);
  }

  const common_toggle_handler = ({ event, obj, list }) => {
    let base_chart_id = data.scenario_name
      .replace(regex, "")
      .concat(data.scenario_id);

    let chart_id = event.target.getAttribute("id_orig");

    if (document.getElementById(base_chart_id)) {
      document.getElementById(base_chart_id).style.display = "none";
    }

    // let block = ({id}) => document.getElementById(id).style.display = "none"
    if (list && list.length) {
      for (let i = 0; i < list.length; i++) {
        let id = list[i].scenario_name
          ? list[i].scenario_name.replace(regex, "").concat(list[i].scenario_id)
          : list[i].scenario_id;

        let id_qq = id + "_orig";
        let id_btn = id + "_button";
        document.getElementById(id_btn).style.color = "";
        document.getElementById(id_btn).style.backgroundColor = "";

        if (id_qq !== chart_id) {
          document.getElementById(id_qq).style.display = "none";
        }
      }
    }
    document.getElementById(chart_id).style.display = "block";

    // styling button

    let id = event.target.getAttribute("id");
    let id_qq = document.getElementById(id);
    id_qq.style.color = "navy";
    id_qq.style.backgroundColor = "#3bcbe3";
    //---------------
  };

  const base_chart_toggle_handler = ({ id, obj, list } = []) => {
    if (id) {
      document.getElementById(id).style.display = "block";
    }
    if (list && list.length) {
      for (let i = 0; i < list.length; i++) {
        let id = list[i].scenario_name
          ? list[i].scenario_name.replace(regex, "").concat(list[i].scenario_id)
          : list[i].scenario_id;

        let id_qq = id + "_orig";
        let id_btn = id + "_button";
        document.getElementById(id_btn).style.color = "";
        document.getElementById(id_btn).style.backgroundColor = "";

        if (id_qq) {
          document.getElementById(id_qq).style.display = "none";
        }
      }
    }
  };

  const commonButton = ({ list }) => {
    if (!list) return;

    return list.map((e, i) => {
      let ID = e.scenario_name
        ? e.scenario_name.replace(regex, "").concat(e.scenario_id)
        : e.scenario_id;
      let ID_ORIG = e.scenario_name
        ? e.scenario_name.replace(regex, "").concat(e.scenario_id) + "_orig"
        : e.scenario_id + "_orig";
      return (
        <button
          title={`${e.scenario_name}/${e.scenario_id}`}
          id={ID + "_button"}
          id_orig={ID_ORIG}
          onClick={(event) => common_toggle_handler({ event, obj: e, list })}
          className="card_btn_orig_small"
          key={`${e.scenario_name}-${i}`}
        >
          {i + 1}
        </button>
      );
    });
  };
  // ************************************

  const fund_annualized =
    Math.round((data.fund_annualized_return * 1000) / 10) / 100;

  const innerCard = (Data) => {
    let string_orig = "";
    let filtered_data = [];
    let filter_compare_data = [];
    let CardID = "";
    let CardID_ORIG = "";
    let filter_client_data_from_backtest = [];

    if (link !== false) {
      string_orig = Data.scenario_name.concat("_orig").toLowerCase();

      filtered_data = sortedData.filter(
        (e) => e.scenario_name.toLowerCase().indexOf(string_orig) !== -1
      );

      filter_compare_data = compare.filter(
        (e) => e.scenario_id === Data.client_portfolio_id
      );

      CardID = Data.scenario_name.replace(regex, "").concat(Data.scenario_id);

      if (filtered_data.length > 0) {
        CardID_ORIG = `${filtered_data[0].scenario_name.replace(regex, "")}${
          // data.scenario_id
          filtered_data[0]["scenario_id"]
        }`;
      } else if (Data && Data.client_portfolio_id) {
        CardID_ORIG = `${Data.scenario_id}_${Data.client_portfolio_id}`;
        let filtered = sortedData.filter(
          (e) => e.scenario_id === data["client_portfolio_id"]
        );
        filter_client_data_from_backtest =
          filtered.length > 0 ? filtered[0] : Data;

        // filter_client_data_from_backtest =
      } else if (filter_compare_data.length > 0) {
        CardID_ORIG = `${data.scenario_id}_${filter_compare_data[0].scenario_id}`;
      }
    }
    return (
      <div className="card">
        {link === false ? (
          <CardInnerContent
            Data={Data}
            ChartID={`Stacked${props.keyData}`}
            CardID={CardID}
            display={"block"}
            footer={footer}
            border={border}
          />
        ) : (
          <Link
            to={{
              pathname: "/dashboard",
              state: {
                foo: Data.scenario_id,
                heading: Data.scenario_name,
                type: Data.type,
                subHeading: Data.benchmark_name,
                benchmark: Data.benchmark,
                benchmark_name: Data.benchmark_name,
                sortedData,
              },
            }}
            className="LinkDisableStyle"
          >
            <CardInnerContent
              Data={Data}
              ChartID={`Stacked${props.keyData}`}
              CardID={CardID}
              display={"block"}
              footer={footer}
              border={border}
            />
          </Link>
        )}
        {/* Orig card - based or scenario name _orig*/}

        {filtered_data && filtered_data.length > 0 ? (
          <Link
            to={{
              pathname: "/dashboard",
              state: {
                foo: filtered_data[0].scenario_id,
                heading: filtered_data[0].scenario_name,
                type: filtered_data[0].type,
                subHeading: filtered_data[0].benchmark_name,
                benchmark: filtered_data[0].benchmark,
                benchmark_name: filtered_data[0].benchmark_name,
                sortedData,
              },
            }}
            className="LinkDisableStyle"
          >
            <CardInnerContent
              Data={filtered_data[0]}
              ChartID={`Stacked_orig${props.keyData}`}
              CardID={CardID_ORIG}
              display={"none"}
              footer={footer}
              border={border}
            />
          </Link>
        ) : null}

        {/*orig portfolio based on compare data*/}
        {filter_compare_data && filter_compare_data.length > 0 ? (
          <Link
            to={{
              pathname: "/dashboard",
              state: {
                foo: sortedData.filter(
                  (e) =>
                    e.client_portfolio_id == filter_compare_data[0].scenario_id
                )[0]["scenario_id"],
                heading: filter_compare_data[0].scenario_name,
                type: filter_compare_data[0].type,
                subHeading: filter_compare_data[0].benchmark_name,
                benchmark: filter_compare_data[0].benchmark,
                benchmark_name: filter_compare_data[0].benchmark_name,
                client_portfolio_id: sortedData.filter(
                  (e) =>
                    e.client_portfolio_id == filter_compare_data[0].scenario_id
                )[0]["client_portfolio_id"],
                sortedData,
                // filter_compare_data[0].client_portfolio_id,
              },
            }}
            className="LinkDisableStyle"
          >
            <CardInnerContent
              Data={filter_compare_data[0]}
              ChartID={`Stacked_orig${props.keyData}`}
              CardID={CardID_ORIG}
              display={"none"}
              footer={footer}
              border={border}
            />
          </Link>
        ) : null}
        {/* {Data &&
        Data.client_portfolio_id &&
        filter_compare_data.length == 0 &&
        filter_client_data_from_backtest ? (
          <Fragment>
            <Link
              to={{
                pathname: "/dashboard",
                state: {
                  foo: Data.scenario_id,
                  heading: Data.scenario_name,
                  type: Data.type,
                  subHeading: Data.benchmark_name,
                  benchmark: Data.benchmark,
                  benchmark_name: Data.benchmark_name,
                  client_portfolio_id: Data["client_portfolio_id"],
                },
              }}
              className="LinkDisableStyle"
            >
              <CardInnerContent
                Data={filter_client_data_from_backtest}
                ChartID={`Stacked_orig${props.keyData}`}
                CardID={`${CardID_ORIG}_client_orig`}
                display={"none"}
                footer={footer}
                border={border}
              />
            </Link>
          </Fragment>
        ) : null} */}
        {sorted_compare_portfolios && sorted_compare_portfolios.length > 0
          ? sorted_compare_portfolios.map((e, i) => (
              <Fragment key={i}>
                <Link
                  to={{
                    pathname: "/dashboard",
                    state: {
                      foo: e.scenario_id,
                      heading: e.scenario_name,
                      type: e.type,
                      subHeading: e.benchmark_name,
                      benchmark: e.benchmark,
                      benchmark_name: e.benchmark_name,
                      client_portfolio_id: e["client_portfolio_id"],
                      sortedData,
                    },
                  }}
                  className="LinkDisableStyle"
                >
                  {console.log({
                    scenario_id: e.scenario_id,
                    CardId: e.scenario_name
                      ? e.scenario_name
                          .replace(regex, "")
                          .concat(e.scenario_id) + "_orig"
                      : e.scenario_id + "_orig",
                  })}
                  <CardInnerContent
                    Data={e}
                    ChartID={`chart_${e.scenario_id}`}
                    CardID={
                      e.scenario_name
                        ? e.scenario_name
                            .replace(regex, "")
                            .concat(e.scenario_id) + "_orig"
                        : e.scenario_id + "_orig"
                    }
                    display={"none"}
                    footer={footer}
                    border={border}
                  />
                </Link>
              </Fragment>
            ))
          : null}
      </div>
    );
  };
  // *************************************
  const TopHead = () => {
    let CardID = data.scenario_name.replace(regex, "").concat(data.scenario_id);

    var string_orig = data.scenario_name
      ? data.scenario_name.concat("_orig").toLowerCase()
      : null;

    var filtered_data = sortedData
      ? sortedData.filter(
          (e) => e.scenario_name.toLowerCase().indexOf(string_orig) !== -1
        )
      : [];

    let filter_compare_data = compare.filter(
      (e) => e.scenario_id === data.client_portfolio_id
    );

    if (filtered_data.length) {
      return (
        <Fragment>
          {heading !== false ? (
            <div className={"card-TopHead card-topDefaultColor"}>
              {data.scenario_name}
            </div>
          ) : null}
        </Fragment>
      );
    } else if (filter_compare_data.length || data.client_portfolio_id) {
      return (
        <Fragment>
          {heading !== false ? (
            <div className={"card-TopHead card-topDefaultColor"}>
              {data.type ? data.type : "BACKTEST"}
            </div>
          ) : null}
        </Fragment>
      );
    } else if (!data.client_portfolio_id) {
      return (
        <Fragment>
          {heading !== false ? (
            <div
              className={
                // SUMBITTED
                data.scn_status == ("SUBMITTED" || "PROCESSING" || "ERROR")
                  ? "card-TopHead card-topSubmit"
                  : data.type == "LIVE"
                  ? "card-TopHead card-topLive"
                  : "card-TopHead card-topDefaultColor"
              }
              onClick={(e) =>
                base_chart_toggle_handler({
                  id: CardID,
                  list: sorted_compare_portfolios,
                })
              }
            >
              {data.type ? data.type : "BACKTEST"} : {data.scenario_name}/
              {data.scenario_id}
              {/* link symbol with orig id*/}
              {/* {checkSimilarPortfolio(sortedData, data.scenario_name)} */}
            </div>
          ) : null}
        </Fragment>
      );
    }
  };

  // const checkSimilarPortfolio = (sortedData, string) => {
  //   var string_orig = string.concat("_orig").toLowerCase();

  //   var filtered_data = sortedData.filter(
  //     (e) => e.scenario_name.toLowerCase().indexOf(string_orig) !== -1
  //   );

  //   if (filtered_data.length > 0) {
  //     return (
  //       <Fragment>
  //         {filtered_data.length > 0 ? (
  //           <Fragment>
  //             {" "}
  //             <i
  //               className="fa fa-link"
  //               aria-hidden="true"
  //               style={{ color: "#3bcbe3", fontSize: "13px" }}
  //             ></i>{" "}
  //             {filtered_data[0]["scenario_id"]}
  //           </Fragment>
  //         ) : null}
  //       </Fragment>
  //     );
  //   } else if (filtered_data.length === 0) {
  //     if (string.includes("_orig")) {
  //       let str = string.replace("_orig", "");
  //       let data = sortedData.filter(
  //         (d) => d.scenario_name.toLowerCase() === str.toLowerCase()
  //       );
  //       return (
  //         <Fragment>
  //           {data.length > 0 ? (
  //             <Fragment>
  //               {" "}
  //               <i
  //                 className="fa fa-link"
  //                 aria-hidden="true"
  //                 style={{ color: "#3bcbe3", fontSize: "13px" }}
  //               ></i>{" "}
  //               {data[0]["scenario_id"]}
  //             </Fragment>
  //           ) : null}
  //         </Fragment>
  //       );
  //     }
  //   }
  //   return null;
  // };

  const buttonOneHandler = (e) => {
    let name = e.target.getAttribute("name");
    let name_orig = e.target.getAttribute("name_orig");

    if (document.getElementById(name_orig)) {
      document.getElementById(name_orig).style.display = "none";
    }

    if (document.getElementById(name)) {
      document.getElementById(name).style.display = "block";
    }

    // btn color #3bcbe3
    // background-image:linear-gradient(var(--primary-dark-blue), var(--primary-light-blue));
    document.getElementById(`${name}_btn`).style.cssText =
      "color:var(--primary-dark-blue); background-color:#3bcbe3 ;border: 1px solid #3bcbe3;";
    if (document.getElementById(`${name_orig}_btn`)) {
      document.getElementById(`${name_orig}_btn`).style.cssText =
        "color:var(--primary-dark-blue); background-color:#d4d7de; border:1px solid #ccc";
    }
    if (document.getElementById(`${name_orig}_client_btn`)) {
      document.getElementById(`${name_orig}_client_btn`).style.cssText =
        "color:var(--primary-dark-blue); background-color:#d4d7de; border:1px solid #ccc";
    }
  };

  const buttonOneHandler2 = (e) => {
    let name = e.target.getAttribute("name");
    let name_orig = e.target.getAttribute("name_orig");

    if (document.getElementById(name_orig)) {
      document.getElementById(name_orig).style.display = "block";
    }

    if (document.getElementById(name)) {
      document.getElementById(name).style.display = "none";
    }

    // btn
    document.getElementById(`${name}_btn`).style.cssText =
      "color:var(--primary-dark-blue); background-color:#d4d7de; border:1px solid #ccc";
    if (document.getElementById(`${name_orig}_btn`)) {
      document.getElementById(`${name_orig}_btn`).style.cssText =
        "color:var(--primary-dark-blue);background-color:#3bcbe3;border: 1px solid #3bcbe3;";
    }
    if (document.getElementById(`${name_orig}_client_btn`)) {
      document.getElementById(`${name_orig}_client_btn`).style.cssText =
        "color:var(--primary-dark-blue);background-color:#3bcbe3;border: 1px solid #3bcbe3;";
    }
  };

  const Button1 = ({ data, compare }) => {
    let string_orig = data.scenario_name.concat("_orig").toLowerCase();

    let filtered_data = sortedData.filter(
      (e) => e.scenario_name.toLowerCase().indexOf(string_orig) !== -1
    );

    let filter_compare_data = compare.filter(
      (e) => e.scenario_id === data.client_portfolio_id
    );

    // checking obj has the compare_portfolio_id
    // if there add similar to Orig portfolio and iqcio portfolio
    let client_portfolio_id_present;
    if (data && data["client_portfolio_id"]) {
      client_portfolio_id_present = true;
    }

    if (filtered_data.length) {
      let ID = data.scenario_name.replace(regex, "").concat(data.scenario_id);
      let ID_orig = `${filtered_data[0].scenario_name.replace(regex, "")}${
        filtered_data[0].scenario_id
      }`;
      return (
        <button
          name={ID}
          name_orig={ID_orig}
          onClick={(e) => buttonOneHandler(e)}
          id={`${ID}_btn`}
          style={{
            color: "navy",
            backgroundColor: "#3bcbe3",
            border: "1px solid #ccc",
          }}
          className="card_btn_orig"
        >
          {/* {`${data.scn_status}/ ${data.scenario_id}`} */}
          {`IQCIO Model/${data.scenario_id}`}
        </button>
      );
    }
    // if client porfolio id present in BACKTEST data itself
    else if (client_portfolio_id_present && filter_compare_data.length == 0) {
      let ID = data.scenario_name.replace(regex, "").concat(data.scenario_id);
      let ID_orig = `${data.scenario_id}_${data["client_portfolio_id"]}_client_orig`;
      return (
        <button
          name={ID}
          name_orig={ID_orig}
          onClick={(e) => buttonOneHandler(e)}
          id={`${ID}_btn`}
          style={{
            color: "navy",
            backgroundColor: "#3bcbe3",
            border: "1px solid #ccc",
          }}
          className="card_btn_orig"
        >
          {/* {`${data.scn_status}/ ${data.scenario_id}`} */}
          {`${data.scenario_name}/${data.scenario_id}`}
        </button>
      );
    } else if (filter_compare_data.length > 0) {
      let ID = data.scenario_name.replace(regex, "").concat(data.scenario_id);
      let ID_orig = `${data.scenario_id}_${filter_compare_data[0].scenario_id}`;
      return (
        <button
          name={ID}
          name_orig={ID_orig}
          onClick={(e) => buttonOneHandler(e)}
          id={`${ID}_btn`}
          style={{
            color: "navy",
            backgroundColor: "#3bcbe3",
            border: "1px solid #ccc",
          }}
          className="card_btn_orig"
        >
          {/* {`${data.scn_status}/ ${data.scenario_id}`} */}
          {`${data.scenario_name}/${data.scenario_id}`}
        </button>
      );
    } else return null;
  };
  const Button2 = ({ data, compare }) => {
    let string_orig = data.scenario_name.concat("_orig").toLowerCase();

    let filtered_data = sortedData.filter(
      (e) => e.scenario_name.toLowerCase().indexOf(string_orig) !== -1
    );

    let filter_compare_data = compare.filter(
      (e) => e.scenario_id === data.client_portfolio_id
    );

    // checking obj has the compare_portfolio_id
    // if there add similar to Orig portfolio and iqcio portfolio
    let client_portfolio_id_present;
    if (data && data["client_portfolio_id"]) {
      client_portfolio_id_present = true;
    }
    if (filtered_data.length) {
      var ID = data.scenario_name.replace(regex, "").concat(data.scenario_id);
      var ID_orig = `${filtered_data[0].scenario_name.replace(regex, "")}${
        filtered_data[0].scenario_id
      }`;
      return (
        <button
          name={ID}
          name_orig={ID_orig}
          onClick={(e) => buttonOneHandler2(e)}
          id={`${ID_orig}_btn`}
          className="card_btn_orig"
          style={{
            border: "1px solid #ccc",
          }}
        >
          {`ORIGINAL/${filtered_data[0].scenario_id}`}
        </button>
      );
    }
    // if backtest consist of client portfolio id
    else if (client_portfolio_id_present && filter_compare_data.length == 0) {
      let ID = data.scenario_name.replace(regex, "").concat(data.scenario_id);
      let ID_orig = `${data.scenario_id}_${data["client_portfolio_id"]}_client_orig`;
      return (
        <button
          name={ID}
          name_orig={ID_orig}
          onClick={(e) => buttonOneHandler2(e)}
          id={`${ID_orig}_client_btn`}
          className="card_btn_orig"
          style={{
            border: "1px solid #ccc",
          }}
        >
          {`ORIGINAL/${data.client_portfolio_id}`}
        </button>
      );
    } else if (filter_compare_data.length > 0) {
      let ID = data.scenario_name.replace(regex, "").concat(data.scenario_id);
      let ID_orig = `${data.scenario_id}_${filter_compare_data[0].scenario_id}`;
      return (
        <button
          name={ID}
          name_orig={ID_orig}
          onClick={(e) => buttonOneHandler2(e)}
          id={`${ID_orig}_btn`}
          className="card_btn_orig"
          style={{
            border: "1px solid #ccc",
          }}
        >
          {/* {`${data.scn_status}/ ${data.scenario_id}`} */}
          {`ORIGINAL/${filter_compare_data[0].scenario_id}`}
        </button>
      );
    } else return null;
  };

  return (
    <Fragment>
      {data.scenario_name && data.scenario_name.toLowerCase().includes("_orig")
        ? null
        : // list of cards similar scenario_id merged,
          // if any portfolio merged to list present filtering out that repeaded card
          sortedData.filter((e) => e.scenario_id === data.client_portfolio_id)
            .length === 0 && (
            <div>
              {heading !== false && data.scenario_name ? (
                <Fragment>
                  {TopHead()}
                  <div style={{ float: "right" }}>
                    {Button1({ data, compare })}
                    {Button2({ data, compare })}

                    {commonButton({ list: sorted_compare_portfolios })}
                  </div>
                </Fragment>
              ) : null}
              {data.scn_status === "BACKTEST" || data.scn_status === "LIVE" ? (
                <Fragment>{innerCard(data)}</Fragment>
              ) : data.scn_status === "PROCESSING" ||
                data.scn_status === "SUBMITTED" ? (
                <Link
                  to={{
                    pathname: `/portfolio/${data.scenario_id}`,
                    state: {
                      foo: data.scenario_id,
                      heading: data.scenario_name,
                      type: data.type,
                      subHeading: data.benchmark_name,
                      benchmark: data.benchmark,
                      benchmark_name: data.benchmark_name,
                      sortedData: sortedData,
                      // compare_scenario_id : data.
                    },
                  }}
                  className="LinkDisableStyle"
                >
                  <CardCreate scn_status={data.scn_status} footer={footer} />
                </Link>
              ) : (
                <Fragment>{innerCard(data)}</Fragment>
              )}
            </div>
          )}
    </Fragment>
  );
}

export default Cards;



// WEBPACK FOOTER //
// ./src/components/myPortfolios/cards/cards.jsx